/**
 * Botão flutuante de WhatsApp.
 * Porte de `bicicletas_peniel_prototipo.html` linhas 359-361.
 *
 * Diferenças propositais:
 *  - o protótipo usava `animate-bounce`, que salta PARA SEMPRE. Aqui são 3
 *    saltos e para (`animate-saltar-3x`), atrás de `motion-safe:` para
 *    respeitar quem pediu menos movimento;
 *  - é um `<a>`, não um `<button onclick=window.open>` — long-press,
 *    compartilhar e clique do meio passam a funcionar, e o leitor de tela
 *    anuncia como link;
 *  - ganhou `aria-label` (o original tinha só o ícone, sem texto acessível).
 */
import { MENSAGENS, montarLinkWhatsapp } from '@peniel/shared'

import { cn } from '@/shared/lib/cn.js'
import { Icone } from '@/shared/ui/Icone.jsx'
import { useConfigLoja } from '@/shared/hooks/useConfigLoja.js'

export function BotaoWhatsAppFlutuante({
  /** Esconde só abaixo de `lg`, onde a BarraCtaProduto ocupa o rodapé. */
  ocultoNoMobile = false,
}: {
  ocultoNoMobile?: boolean
}) {
  const config = useConfigLoja()

  return (
    // <aside> e não um <a> solto no body: conteúdo fora de landmark some para
    // quem navega por regiões no leitor de tela (o axe acusa `region`). O
    // `fixed` continua no link, então o wrapper não ocupa espaço no layout.
    <aside aria-label="Contato rápido">
      <a
        href={montarLinkWhatsapp(config.whatsappNumero, MENSAGENS.atendimento)}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Falar no WhatsApp (abre em nova aba)"
        className={cn(
          'fixed bottom-6 right-6 z-50 flex size-14 items-center justify-center rounded-full bg-whatsapp text-3xl text-white shadow-whatsapp transition-all hover:scale-105 hover:shadow-whatsapp-forte motion-safe:animate-saltar-3x',
          // Na página de produto o CTA fixo já ocupa o rodapé no mobile; os dois
          // juntos empilhariam dois botões de WhatsApp no mesmo canto.
          ocultoNoMobile && 'max-lg:hidden',
        )}
      >
        <Icone nome="whatsapp" />
      </a>
    </aside>
  )
}
